const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/user/list',
    authenticatedEntryPathStandard: '/app/user/list',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig